const { getElement, trapFocus } = window.BAO.Utils

class ContactModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.handleSubmittedState()
  }

  setupListeners () {
    super.setupListeners()

    this.trigger = this.els?.trigger?.element
    this.close = this.els?.close?.element
    this.modal = this.els?.modal?.element
    this.container = this.externalEls?.container?.element

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)

    if (this.trigger && this.modal) {
      this.listeners.add(this.trigger, `click`, this.handleTriggerClick)
      this.listeners.add(this.close, `click`, this.handleCloseClick)
    }
  }

  handleTriggerClick () {
    this.openModal()
  }

  handleCloseClick () {
    this.closeModal()
  }

  openModal () {
    this.trigger.setAttribute('aria-pressed', 'true')
    this.modal.setAttribute('aria-hidden', 'false')

    trapFocus(this.modal)
  }

  closeModal () {
    trapFocus(this.container)
    this.trigger.focus()

    this.trigger.setAttribute('aria-pressed', 'false')
    this.modal.setAttribute('aria-hidden', 'true')
  }

  handleSubmittedState () {
    const hasSuccessEl = getElement('[data-contact-modal-el="success"]')
    const currentUrl = new URL(window.location.href)

    if (
      hasSuccessEl &&
      currentUrl.searchParams.get('contact_posted') === 'true'
    ) {
      window.drawers.activeDrawerKey = 'help'
      this.openModal()

      currentUrl.searchParams.delete('contact_posted')
      window.history.replaceState({}, '', currentUrl)

      setTimeout(() => {
        const submitEl = this.els?.submit?.element

        if (submitEl) {
          submitEl.innerHTML = submitEl.dataset.defaultText
        }
      }, 4000)
    }
  }
}

if (!customElements.get('contact-modal')) {
  customElements.define('contact-modal', ContactModal)
}
